import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { AiFillHtml5 } from 'react-icons/ai';
import { DiCss3, DiJavascript, DiMysql } from 'react-icons/di';
import { FaBootstrap, FaGitAlt, FaNodeJs, FaSass, FaWordpress } from 'react-icons/fa';
import { RiReactjsFill } from 'react-icons/ri';
import { SiChakraui, SiDigitalocean, SiExpress, SiHeroku, SiLinux, SiMongodb, SiNetlify, SiNginx, SiPostgresql, SiPostman, SiPrisma, SiRedux, SiTailwindcss, SiTypescript } from 'react-icons/si';
import { TbBrandNextjs } from 'react-icons/tb';
import styled from 'styled-components';
import Skill from '../Components/Skill';
import Title from '../Components/Title';
import { InnerLayout, MainLayout } from '../Styles/mainLayouts';

const SkillsStyled = styled.section`
    .skills{
        width:98%;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-row-gap: 2rem;
        grid-column-gap: 3rem;
        .icon{
            font-size:67px;
        }
        @media screen and (max-width: 950px){
            grid-template-columns: repeat(3, 1fr);
        }
        @media screen and (max-width: 700px){
            grid-template-columns: repeat(2, 1fr);
            overflow: hidden;
            padding-bottom: 28px;
        }
        @media screen and (max-width: 500px){
            grid-template-columns: repeat(1, 1fr);
            margin: auto;
            padding: 0 10%;
        }
    }
`;

const SkillsPage = ({ theme }) => {
    useEffect(() => {
        AOS.init({ duration: 2500, })
    }, [])

    const skills = [
        { skill: "NextJs", icon: <TbBrandNextjs className="icon" /> },
        { skill: "TypeScript", icon: <SiTypescript className="icon" /> },
        { skill: "React Js", icon: <RiReactjsFill className="icon" /> },
        { skill: "Redux", icon: <SiRedux className="icon" /> },
        { skill: "JavaScript", icon: <DiJavascript className="icon" /> },
        { skill: "NodeJs", icon: <FaNodeJs className="icon" /> },
        { skill: "ExpressJs", icon: <SiExpress className="icon" /> },
        { skill: "MongoDB", icon: <SiMongodb className="icon" /> },
        { skill: "PostgreSQL", icon: <SiPostgresql className="icon" /> },
        { skill: "MySQL", icon: <DiMysql className="icon" /> },
        { skill: "Prisma", icon: <SiPrisma className="icon" /> },
        { skill: "Wordpress", icon: <FaWordpress className="icon" /> },
        { skill: "DigitalOcean", icon: <SiDigitalocean className="icon" /> },
        { skill: "Nginx", icon: <SiNginx className="icon" /> },
        { skill: "HTML5", icon: <AiFillHtml5 className="icon" /> },
        { skill: "CSS3", icon: <DiCss3 className="icon" /> },
        { skill: "Sass", icon: <FaSass className="icon" /> },
        { skill: "Tailwind-UI", icon: <SiTailwindcss className="icon" /> },
        { skill: "Bootstrap", icon: <FaBootstrap className="icon" /> },
        { skill: "Chakra-UI", icon: <SiChakraui className="icon" /> },
        { skill: "Linux", icon: <SiLinux className="icon" /> },
        { skill: "Postman", icon: <SiPostman className="icon" /> },
        { skill: "Heroku", icon: <SiHeroku className="icon" /> },
        { skill: "Netlify", icon: <SiNetlify className="icon" /> },
        { skill: "Git", icon: <FaGitAlt className="icon" /> },
    ]

    return (
        <div id="SkillsPage">
            <MainLayout>
                <SkillsStyled>
                    <Title title={'Skills'} />
                    <InnerLayout>
                        <div className="skills">
                            {skills.map((el, i) => (
                                i % 2 === 0 ?
                                    <div key={i} data-aos="fade-right">
                                        <Skill
                                            title={el.skill}
                                            icon={el.icon}
                                        />
                                    </div>
                                    : <div key={i} data-aos="fade-left">
                                        <Skill
                                            title={el.skill}
                                            icon={el.icon}
                                        />
                                    </div>
                            ))}
                        </div>
                    </InnerLayout>
                </SkillsStyled>
            </MainLayout>
        </div>
    )
}
export default SkillsPage